import { type ReactNode } from "react";

import {
  ConfirmationDialog,
  type ConfirmationDialogProps,
} from "@/components/confirmation-dialog";

interface DeleteConfirmationDialogProps {
  title: string;
  description: ReactNode;
  /** May return a promise; see `ConfirmationDialog` for the pending behaviour. */
  onConfirm: ConfirmationDialogProps["onConfirm"];
  disabled?: boolean;
  confirmLabel?: string;
  children: ReactNode;
}

export function DeleteConfirmationDialog({
  title,
  description,
  onConfirm,
  disabled,
  confirmLabel = "Delete",
  children,
}: DeleteConfirmationDialogProps) {
  return (
    <ConfirmationDialog
      title={title}
      description={description}
      onConfirm={onConfirm}
      disabled={disabled}
      confirmLabel={confirmLabel}
      confirmVariant="destructive"
    >
      {children}
    </ConfirmationDialog>
  );
}
